import { ApiRoutes } from '@/services/ApiRoutes.js';
import { BackendAPI } from '@/services/BackendAPI.js';

export default {
  all(data = {}) {
    return BackendAPI('get', ApiRoutes.askTeacher.all(), data);
  },
  get(id) {
    return BackendAPI('get', ApiRoutes.askTeacher.get(id));
  },
  reply(id, data) {
    return BackendAPI('put', ApiRoutes.askTeacher.reply(id), data);
  },
};
